export default __webpack_public_path__ + "static/media/LTO-BNB.cfc52bd3.svg";